import { render } from "./program-card.vue?vue&type=template&id=05afb31f&lang=pug"
import script from "./program-card.vue?vue&type=script&lang=js"
export * from "./program-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__